import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { sync } from 'vuex-router-sync';

import ElementUI from 'element-ui';
import Axios from '@/assets/plugin/axios';
import checkResp from '@/assets/plugin/checkResp';
import handleError from '@/assets/plugin/handleError';
import watchOnce from '@/assets/plugin/watchOnce';
import TrackPlugin from '@/assets/plugin/track';
import infiniteScroll from 'vue-infinite-scroll';

/* eslint-disable */
'use strict'; Promise.prototype.finally = function(t) { var n = this.constructor; return this.then(function(r) { return n.resolve(t()).then(function() { return r; }); }, function(r) { return n.resolve(t()).then(function() { throw r; }); }); };

// sync the router with the vuex store.
// this registers `store.state.route`
sync(store, router);

Vue.use(ElementUI);
Vue.use(Axios);
Vue.use(checkResp);
Vue.use(handleError);
Vue.use(watchOnce);
Vue.use(TrackPlugin, feConfig.trackPoint);
Vue.use(infiniteScroll);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/views/index/app.js